/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Avallon API
 * OpenAPI spec version: 1.0.0
 */

import {
  McpServer,
  type RegisteredTool,
} from '@modelcontextprotocol/sdk/server/mcp.js';

import {
  StdioServerTransport
} from '@modelcontextprotocol/sdk/server/stdio.js';

import {
  listVoiceAgentsHandler,
  createVoiceAgentHandler,
  getVoiceAgentHandler,
  updateVoiceAgentHandler,
  deleteVoiceAgentHandler,
  listVoiceAgentVersionsHandler,
  getVoiceAgentVersionHandler,
  promoteVoiceAgentVersionHandler,
  getVoiceAgentVersionChangeSummaryHandler,
  getVoiceAgentPlaceholdersHandler,
  getVoiceAgentPromptHandler,
  updateVoiceAgentPromptHandler,
  updateVoiceAgentModelsHandler,
  updateCallControlsHandler,
  scheduleJobHandler,
  listJobsHandler,
  cancelJobHandler,
  listApiKeysHandler,
  createApiKeyHandler,
  revokeApiKeyHandler,
  updateApiKeyHandler,
  createArtifactHandler,
  listArtifactsHandler,
  getArtifactHandler,
  deleteArtifactHandler,
  getArtifactMetadataKeysHandler,
  getArtifactStatusSummaryHandler,
  getArtifactUploadUrlHandler,
  updateArtifactMetadataHandler,
  signUpHandler,
  signInHandler,
  requestPasswordResetHandler,
  resetPasswordHandler,
  refreshTokenHandler,
  getOAuthUrlHandler,
  getSessionTokenHandler,
  getPartnerJwksHandler,
  partnerLaunchHandler,
  listCallsHandler,
  getCallHandler,
  getCallEvaluationHandler,
  getCallAnalyticsHandler,
  getAnalyticsTimeSeriesHandler,
  createCallFeedbackHandler,
  listCallFeedbackHandler,
  deleteCallFeedbackHandler,
  checkInboxAvailabilityHandler,
  createInboxHandler,
  listInboxesHandler,
  updateInboxHandler,
  deleteInboxHandler,
  getEmailHandler,
  deleteEmailHandler,
  listEmailsHandler,
  listEmailThreadsHandler,
  replyToEmailHandler,
  sendEmailHandler,
  listExtractorJobsHandler,
  createExtractorJobHandler,
  getExtractorJobHandler,
  listWorkerRunsHandler,
  createWorkerRunHandler,
  getWorkerRunHandler,
  listWorkerRunMessagesHandler,
  cancelWorkerRunHandler,
  createWorkerEvalFromRunHandler,
  runEvalHandler,
  getEvalRunHandler,
  createExtractorHandler,
  listExtractorsHandler,
  getExtractorHandler,
  updateExtractorHandler,
  deleteExtractorHandler,
  createWorkerHandler,
  listWorkersHandler,
  getWorkerHandler,
  deleteWorkerHandler,
  updateWorkerHandler,
  getWorkerPromptHandler,
  updateWorkerPromptHandler,
  listWorkerModelsHandler,
  updateWorkerMcpsHandler,
  listWorkerVersionsHandler,
  getWorkerVersionHandler,
  promoteWorkerVersionHandler,
  getWorkerVersionChangeSummaryHandler,
  createWorkerWebhookHandler,
  listWorkerWebhooksHandler,
  listCasesHandler,
  createCaseHandler,
  searchCasesHandler,
  getCaseHandler,
  addCaseLinksHandler,
  listCaseLinksHandler,
  removeCaseLinkHandler,
  createChatAgentHandler,
  listChatAgentsHandler,
  getChatAgentHandler,
  updateChatAgentHandler,
  deleteChatAgentHandler,
  getChatAgentPromptHandler,
  updateChatAgentPromptHandler,
  createChatHandler,
  getChatHandler,
  getPublicChatAgentHandler,
  postChatMessageHandler,
  listChatsHandler,
  listChatMessagesHandler,
  getExtractHandler,
  getExtractCitationsHandler,
  listExtractsHandler,
  getProfileHandler,
  listTeamMembersHandler,
  inviteTeamMemberHandler,
  listTeamInvitationsHandler,
  revokeTeamInvitationHandler,
  resendTeamInvitationHandler,
  updateMemberRoleHandler,
  removeMemberHandler,
  createSecretHandler,
  listSecretsHandler,
  getSecretHandler,
  updateSecretHandler,
  deleteSecretHandler,
  createScheduleHandler,
  listSchedulesHandler,
  getScheduleHandler,
  updateScheduleHandler,
  deleteScheduleHandler,
  listDispatchesHandler,
  listNotificationsHandler,
  createInformationRequestHandler,
  listInformationRequestsHandler,
  getInformationRequestHandler,
  resolveInformationRequestHandler,
  createToolHandler,
  listToolsHandler,
  deleteToolHandler,
  getToolHandler,
  updateToolHandler,
  executeCodeHandler,
  listToolVersionsHandler,
  getToolVersionHandler,
  promoteToolVersionHandler,
  getToolVersionChangeSummaryHandler,
  workerListToolsHandler,
  workerGetToolHandler,
  workerExecuteToolHandler,
  notifyAdminHandler,
  uploadFileHandler,
  createAgentWebhookHandler,
  listAgentWebhooksHandler,
  createInboxWebhookHandler,
  listInboxWebhooksHandler,
  createExtractorWebhookHandler,
  listWebhooksHandler,
  createNotificationWebhookHandler,
  listNotificationWebhooksHandler,
  deleteWebhookHandler,
  getWebhookHandler,
  updateWebhookHandler,
  listWebhookDeliveriesHandler,
  testWebhookHandler
} from './handlers';
import {
  ListVoiceAgentsQueryParams,
  ListVoiceAgentsResponse,
  CreateVoiceAgentBody,
  CreateVoiceAgentResponse,
  GetVoiceAgentParams,
  GetVoiceAgentResponse,
  UpdateVoiceAgentParams,
  UpdateVoiceAgentBody,
  UpdateVoiceAgentResponse,
  DeleteVoiceAgentParams,
  DeleteVoiceAgentResponse,
  ListVoiceAgentVersionsParams,
  ListVoiceAgentVersionsQueryParams,
  ListVoiceAgentVersionsResponse,
  GetVoiceAgentVersionParams,
  GetVoiceAgentVersionResponse,
  PromoteVoiceAgentVersionParams,
  PromoteVoiceAgentVersionBody,
  PromoteVoiceAgentVersionResponse,
  GetVoiceAgentVersionChangeSummaryParams,
  GetVoiceAgentVersionChangeSummaryResponse,
  GetVoiceAgentPlaceholdersParams,
  GetVoiceAgentPlaceholdersResponse,
  GetVoiceAgentPromptParams,
  GetVoiceAgentPromptQueryParams,
  GetVoiceAgentPromptResponse,
  UpdateVoiceAgentPromptParams,
  UpdateVoiceAgentPromptBody,
  UpdateVoiceAgentPromptResponse,
  UpdateVoiceAgentModelsParams,
  UpdateVoiceAgentModelsBody,
  UpdateVoiceAgentModelsResponse,
  UpdateCallControlsParams,
  UpdateCallControlsBody,
  UpdateCallControlsResponse,
  ScheduleJobParams,
  ScheduleJobBody,
  ScheduleJobResponse,
  ListJobsQueryParams,
  ListJobsResponse,
  CancelJobParams,
  CancelJobResponse,
  ListApiKeysQueryParams,
  ListApiKeysResponse,
  CreateApiKeyBody,
  CreateApiKeyResponse,
  RevokeApiKeyParams,
  RevokeApiKeyResponse,
  UpdateApiKeyParams,
  UpdateApiKeyBody,
  UpdateApiKeyResponse,
  CreateArtifactBody,
  CreateArtifactResponse,
  ListArtifactsQueryParams,
  ListArtifactsResponse,
  GetArtifactParams,
  GetArtifactResponse,
  DeleteArtifactParams,
  DeleteArtifactResponse,
  GetArtifactMetadataKeysQueryParams,
  GetArtifactMetadataKeysResponse,
  GetArtifactStatusSummaryQueryParams,
  GetArtifactStatusSummaryResponse,
  GetArtifactUploadUrlBody,
  GetArtifactUploadUrlResponse,
  UpdateArtifactMetadataParams,
  UpdateArtifactMetadataBody,
  UpdateArtifactMetadataResponse,
  SignUpBody,
  SignUpResponse,
  SignInBody,
  SignInResponse,
  RequestPasswordResetBody,
  RequestPasswordResetResponse,
  ResetPasswordBody,
  ResetPasswordResponse,
  RefreshTokenBody,
  RefreshTokenResponse,
  GetOAuthUrlQueryParams,
  GetOAuthUrlResponse,
  GetSessionTokenBody,
  GetSessionTokenResponse,
  GetPartnerJwksParams,
  GetPartnerJwksResponse,
  PartnerLaunchQueryParams,
  PartnerLaunchResponse,
  ListCallsQueryParams,
  ListCallsResponse,
  GetCallParams,
  GetCallQueryParams,
  GetCallResponse,
  GetCallEvaluationParams,
  GetCallEvaluationResponse,
  GetCallAnalyticsQueryParams,
  GetCallAnalyticsResponse,
  GetAnalyticsTimeSeriesQueryParams,
  GetAnalyticsTimeSeriesResponse,
  CreateCallFeedbackParams,
  CreateCallFeedbackBody,
  CreateCallFeedbackResponse,
  ListCallFeedbackParams,
  ListCallFeedbackQueryParams,
  ListCallFeedbackResponse,
  DeleteCallFeedbackParams,
  DeleteCallFeedbackResponse,
  CheckInboxAvailabilityQueryParams,
  CheckInboxAvailabilityResponse,
  CreateInboxBody,
  CreateInboxResponse,
  ListInboxesQueryParams,
  ListInboxesResponse,
  UpdateInboxParams,
  UpdateInboxBody,
  UpdateInboxResponse,
  DeleteInboxParams,
  DeleteInboxResponse,
  GetEmailParams,
  GetEmailResponse,
  DeleteEmailParams,
  DeleteEmailResponse,
  ListEmailsQueryParams,
  ListEmailsResponse,
  ListEmailThreadsQueryParams,
  ListEmailThreadsResponse,
  ReplyToEmailParams,
  ReplyToEmailBody,
  ReplyToEmailResponse,
  SendEmailBody,
  SendEmailResponse,
  ListExtractorJobsQueryParams,
  ListExtractorJobsResponse,
  CreateExtractorJobBody,
  CreateExtractorJobResponse,
  GetExtractorJobParams,
  GetExtractorJobResponse,
  ListWorkerRunsQueryParams,
  ListWorkerRunsResponse,
  CreateWorkerRunBody,
  CreateWorkerRunResponse,
  GetWorkerRunParams,
  GetWorkerRunResponse,
  ListWorkerRunMessagesParams,
  ListWorkerRunMessagesQueryParams,
  ListWorkerRunMessagesResponse,
  CancelWorkerRunParams,
  CancelWorkerRunResponse,
  CreateWorkerEvalFromRunParams,
  CreateWorkerEvalFromRunBody,
  CreateWorkerEvalFromRunResponse,
  RunEvalParams,
  RunEvalResponse,
  GetEvalRunParams,
  GetEvalRunResponse,
  CreateExtractorBody,
  CreateExtractorResponse,
  ListExtractorsQueryParams,
  ListExtractorsResponse,
  GetExtractorParams,
  GetExtractorResponse,
  UpdateExtractorParams,
  UpdateExtractorBody,
  UpdateExtractorResponse,
  DeleteExtractorParams,
  DeleteExtractorResponse,
  CreateWorkerBody,
  CreateWorkerResponse,
  ListWorkersQueryParams,
  ListWorkersResponse,
  GetWorkerParams,
  GetWorkerResponse,
  DeleteWorkerParams,
  DeleteWorkerResponse,
  UpdateWorkerParams,
  UpdateWorkerBody,
  UpdateWorkerResponse,
  GetWorkerPromptParams,
  GetWorkerPromptQueryParams,
  GetWorkerPromptResponse,
  UpdateWorkerPromptParams,
  UpdateWorkerPromptBody,
  UpdateWorkerPromptResponse,
  ListWorkerModelsResponse,
  UpdateWorkerMcpsParams,
  UpdateWorkerMcpsBody,
  UpdateWorkerMcpsResponse,
  ListWorkerVersionsParams,
  ListWorkerVersionsQueryParams,
  ListWorkerVersionsResponse,
  GetWorkerVersionParams,
  GetWorkerVersionResponse,
  PromoteWorkerVersionParams,
  PromoteWorkerVersionBody,
  PromoteWorkerVersionResponse,
  GetWorkerVersionChangeSummaryParams,
  GetWorkerVersionChangeSummaryResponse,
  CreateWorkerWebhookParams,
  CreateWorkerWebhookBody,
  CreateWorkerWebhookResponse,
  ListWorkerWebhooksParams,
  ListWorkerWebhooksQueryParams,
  ListWorkerWebhooksResponse,
  ListCasesQueryParams,
  ListCasesResponse,
  CreateCaseBody,
  CreateCaseResponse,
  SearchCasesQueryParams,
  SearchCasesResponse,
  GetCaseParams,
  GetCaseQueryParams,
  GetCaseResponse,
  AddCaseLinksParams,
  AddCaseLinksQueryParams,
  AddCaseLinksBody,
  AddCaseLinksResponse,
  ListCaseLinksParams,
  ListCaseLinksQueryParams,
  ListCaseLinksResponse,
  RemoveCaseLinkParams,
  RemoveCaseLinkQueryParams,
  RemoveCaseLinkResponse,
  CreateChatAgentBody,
  CreateChatAgentResponse,
  ListChatAgentsQueryParams,
  ListChatAgentsResponse,
  GetChatAgentParams,
  GetChatAgentResponse,
  UpdateChatAgentParams,
  UpdateChatAgentBody,
  UpdateChatAgentResponse,
  DeleteChatAgentParams,
  DeleteChatAgentResponse,
  GetChatAgentPromptParams,
  GetChatAgentPromptResponse,
  UpdateChatAgentPromptParams,
  UpdateChatAgentPromptBody,
  UpdateChatAgentPromptResponse,
  CreateChatBody,
  CreateChatResponse,
  GetChatParams,
  GetChatResponse,
  GetPublicChatAgentParams,
  GetPublicChatAgentResponse,
  PostChatMessageParams,
  PostChatMessageBody,
  PostChatMessageResponse,
  ListChatsQueryParams,
  ListChatsResponse,
  ListChatMessagesParams,
  ListChatMessagesQueryParams,
  ListChatMessagesResponse,
  GetExtractParams,
  GetExtractResponse,
  GetExtractCitationsParams,
  GetExtractCitationsResponse,
  ListExtractsQueryParams,
  ListExtractsResponse,
  GetProfileResponse,
  ListTeamMembersResponse,
  InviteTeamMemberBody,
  InviteTeamMemberResponse,
  ListTeamInvitationsResponse,
  RevokeTeamInvitationParams,
  RevokeTeamInvitationResponse,
  ResendTeamInvitationParams,
  ResendTeamInvitationResponse,
  UpdateMemberRoleParams,
  UpdateMemberRoleBody,
  UpdateMemberRoleResponse,
  RemoveMemberParams,
  RemoveMemberResponse,
  CreateSecretBody,
  CreateSecretResponse,
  ListSecretsQueryParams,
  ListSecretsResponse,
  GetSecretParams,
  GetSecretResponse,
  UpdateSecretParams,
  UpdateSecretBody,
  UpdateSecretResponse,
  DeleteSecretParams,
  DeleteSecretResponse,
  CreateScheduleBody,
  CreateScheduleResponse,
  ListSchedulesQueryParams,
  ListSchedulesResponse,
  GetScheduleParams,
  GetScheduleResponse,
  UpdateScheduleParams,
  UpdateScheduleBody,
  UpdateScheduleResponse,
  DeleteScheduleParams,
  DeleteScheduleResponse,
  ListDispatchesQueryParams,
  ListDispatchesResponse,
  ListNotificationsQueryParams,
  ListNotificationsResponse,
  CreateInformationRequestBody,
  CreateInformationRequestResponse,
  ListInformationRequestsQueryParams,
  ListInformationRequestsResponse,
  GetInformationRequestParams,
  GetInformationRequestResponse,
  ResolveInformationRequestParams,
  ResolveInformationRequestBody,
  ResolveInformationRequestResponse,
  CreateToolBody,
  CreateToolResponse,
  ListToolsQueryParams,
  ListToolsResponse,
  DeleteToolParams,
  DeleteToolResponse,
  GetToolParams,
  GetToolResponse,
  UpdateToolParams,
  UpdateToolBody,
  UpdateToolResponse,
  ExecuteCodeParams,
  ExecuteCodeBody,
  ExecuteCodeResponse,
  ListToolVersionsParams,
  ListToolVersionsQueryParams,
  ListToolVersionsResponse,
  GetToolVersionParams,
  GetToolVersionResponse,
  PromoteToolVersionParams,
  PromoteToolVersionBody,
  PromoteToolVersionResponse,
  GetToolVersionChangeSummaryParams,
  GetToolVersionChangeSummaryResponse,
  WorkerListToolsQueryParams,
  WorkerListToolsResponse,
  WorkerGetToolParams,
  WorkerGetToolResponse,
  WorkerExecuteToolParams,
  WorkerExecuteToolBody,
  WorkerExecuteToolResponse,
  NotifyAdminBody,
  NotifyAdminResponse,
  UploadFileBody,
  UploadFileResponse,
  CreateAgentWebhookParams,
  CreateAgentWebhookBody,
  CreateAgentWebhookResponse,
  ListAgentWebhooksParams,
  ListAgentWebhooksQueryParams,
  ListAgentWebhooksResponse,
  CreateInboxWebhookParams,
  CreateInboxWebhookBody,
  CreateInboxWebhookResponse,
  ListInboxWebhooksParams,
  ListInboxWebhooksQueryParams,
  ListInboxWebhooksResponse,
  CreateExtractorWebhookParams,
  CreateExtractorWebhookBody,
  CreateExtractorWebhookResponse,
  ListWebhooksParams,
  ListWebhooksQueryParams,
  ListWebhooksResponse,
  CreateNotificationWebhookBody,
  CreateNotificationWebhookResponse,
  ListNotificationWebhooksQueryParams,
  ListNotificationWebhooksResponse,
  DeleteWebhookParams,
  DeleteWebhookResponse,
  GetWebhookParams,
  GetWebhookResponse,
  UpdateWebhookParams,
  UpdateWebhookBody,
  UpdateWebhookResponse,
  ListWebhookDeliveriesParams,
  ListWebhookDeliveriesQueryParams,
  ListWebhookDeliveriesResponse,
  TestWebhookParams,
  TestWebhookBody,
  TestWebhookResponse
} from './tool-schemas.zod';

const createMcpServer = (options?: RequestInit): { server: McpServer; tools: Record<string, RegisteredTool> } => {
  const server = new McpServer({
    name: 'avallonAPIServer',
    version: '1.0.0',
  });
  const tools: Record<string, RegisteredTool> = {};

tools.listVoiceAgents = server.registerTool(
  'listVoiceAgents',
  {
    title: 'List voice agents',
    description: 'List all voice agents for your tenant.\n\n\*\*Filtering:\*\*\n\nFilter voice agents by name using the `agent_name` query parameter (exact match).\n\n\*\*Response:\*\*\n\nReturns an array of all voice agents with their configurations and a total count.\n\nFor compatibility this endpoint is also available using the following (deprecated) paths:\n`GET \/v1\/agents`',
    inputSchema: {
      queryParams: ListVoiceAgentsQueryParams
    },
    outputSchema: ListVoiceAgentsResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listVoiceAgentsHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.createVoiceAgent = server.registerTool(
  'createVoiceAgent',
  {
    title: 'Create voice agent',
    description: 'Create a new voice agent with the specified configuration.\n\n\*\*Required fields:\*\*\n\nAll fields in the request body are required except `phone_number_id` and `transfer_phone_number`.\n\n\*\*Response:\*\*\n\nReturns the created voice agent with its ID and configuration.\n\nFor compatibility this endpoint is also available using the following (deprecated) paths:\n`POST \/v1\/agents`',
    inputSchema: {
      bodyParams: CreateVoiceAgentBody.optional()
    },
    outputSchema: CreateVoiceAgentResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => createVoiceAgentHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getVoiceAgent = server.registerTool(
  'getVoiceAgent',
  {
    title: 'Get voice agent',
    description: 'Retrieve a single voice agent by its ID.\n\nFor compatibility this endpoint is also available using the following (deprecated) paths:\n`GET \/v1\/agents\/{id}`',
    inputSchema: {
      pathParams: GetVoiceAgentParams
    },
    outputSchema: GetVoiceAgentResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getVoiceAgentHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.updateVoiceAgent = server.registerTool(
  'updateVoiceAgent',
  {
    title: 'Update voice agent',
    description: 'Update a voice agent\'s name, call processor, or call behaviour settings.\n\nTo change the processor assignment, `call_processor_id` and `call_processor_type` must be provided together. Set `call_processor_id` to `null` to detach (`call_processor_type` is still required).\n\nSet `voice_mail_detection` to `true` to have the agent listen for a voicemail beep tone. Detection only runs on `OUTBOUND` agents; enabling it on an `INBOUND` agent is stored but has no effect.\n\nSet `noise_cancellation` to choose the noise cancellation mode applied to the caller audio.\n\nSet `tool_ids` to replace the agent\'s attached tool set. This is the supported way to manage tool attachments; the dedicated add and remove endpoints are deprecated.\n\nConfig changes create a new voice agent config version. The live and test releases keep pointing at their current versions until the new version is promoted.',
    inputSchema: {
      pathParams: UpdateVoiceAgentParams,
      bodyParams: UpdateVoiceAgentBody.optional()
    },
    outputSchema: UpdateVoiceAgentResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => updateVoiceAgentHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.deleteVoiceAgent = server.registerTool(
  'deleteVoiceAgent',
  {
    title: 'Delete voice agent',
    description: 'Delete a voice agent. The agent is hidden from all reads; its call and job history is preserved.',
    inputSchema: {
      pathParams: DeleteVoiceAgentParams
    },
    outputSchema: DeleteVoiceAgentResponse,
    annotations: { destructiveHint: true, idempotentHint: true },
  },
  (args, ctx) => deleteVoiceAgentHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listVoiceAgentVersions = server.registerTool(
  'listVoiceAgentVersions',
  {
    title: 'List voice agent versions',
    description: 'List all config versions for a voice agent, ordered by version (newest first by default).',
    inputSchema: {
      pathParams: ListVoiceAgentVersionsParams,
      queryParams: ListVoiceAgentVersionsQueryParams
    },
    outputSchema: ListVoiceAgentVersionsResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listVoiceAgentVersionsHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getVoiceAgentVersion = server.registerTool(
  'getVoiceAgentVersion',
  {
    title: 'Get voice agent version',
    description: 'Retrieve a single voice agent config version, including the agent\'s identity, the config snapshot at that version, and version-specific metadata.',
    inputSchema: {
      pathParams: GetVoiceAgentVersionParams
    },
    outputSchema: GetVoiceAgentVersionResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getVoiceAgentVersionHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.promoteVoiceAgentVersion = server.registerTool(
  'promoteVoiceAgentVersion',
  {
    title: 'Promote voice agent version',
    description: 'Select a voice agent configuration version for the live or test environment.',
    inputSchema: {
      pathParams: PromoteVoiceAgentVersionParams,
      bodyParams: PromoteVoiceAgentVersionBody.optional()
    },
    outputSchema: PromoteVoiceAgentVersionResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => promoteVoiceAgentVersionHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getVoiceAgentVersionChangeSummary = server.registerTool(
  'getVoiceAgentVersionChangeSummary',
  {
    title: 'Get voice agent version change summary',
    description: 'Returns an AI-generated summary of what changed between this version and the previous one. Initial version returns an empty string since there is no predecessor.',
    inputSchema: {
      pathParams: GetVoiceAgentVersionChangeSummaryParams
    },
    outputSchema: GetVoiceAgentVersionChangeSummaryResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getVoiceAgentVersionChangeSummaryHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getVoiceAgentPlaceholders = server.registerTool(
  'getVoiceAgentPlaceholders',
  {
    title: 'Get voice agent placeholders',
    description: 'Retrieve the available placeholder variables defined in a voice agent\'s prompt.\n\nFor compatibility this endpoint is also available using the following (deprecated) paths:\n`GET \/v1\/agents\/{id}\/prompt`',
    inputSchema: {
      pathParams: GetVoiceAgentPlaceholdersParams
    },
    outputSchema: GetVoiceAgentPlaceholdersResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getVoiceAgentPlaceholdersHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getVoiceAgentPrompt = server.registerTool(
  'getVoiceAgentPrompt',
  {
    title: 'Get voice agent prompt',
    description: 'Retrieve the prompt for a voice agent. Pass `version` to fetch the prompt snapshot at a specific config version; omit it to fetch the current prompt. Internal use only.',
    inputSchema: {
      pathParams: GetVoiceAgentPromptParams,
      queryParams: GetVoiceAgentPromptQueryParams
    },
    outputSchema: GetVoiceAgentPromptResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getVoiceAgentPromptHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.updateVoiceAgentPrompt = server.registerTool(
  'updateVoiceAgentPrompt',
  {
    title: 'Update voice agent prompt',
    description: 'Update the prompt for a voice agent. Internal use only.',
    inputSchema: {
      pathParams: UpdateVoiceAgentPromptParams,
      bodyParams: UpdateVoiceAgentPromptBody.optional()
    },
    outputSchema: UpdateVoiceAgentPromptResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => updateVoiceAgentPromptHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.updateVoiceAgentModels = server.registerTool(
  'updateVoiceAgentModels',
  {
    title: 'Update voice agent models',
    description: 'Update the LLM, TTS, and STT model configuration for a voice agent.\n\nFor compatibility this endpoint is also available using the following (deprecated) paths:\n`PATCH \/v1\/agents\/{id}\/models`',
    inputSchema: {
      pathParams: UpdateVoiceAgentModelsParams,
      bodyParams: UpdateVoiceAgentModelsBody.optional()
    },
    outputSchema: UpdateVoiceAgentModelsResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => updateVoiceAgentModelsHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.updateCallControls = server.registerTool(
  'updateCallControls',
  {
    title: 'Update voice agent call controls',
    description: 'Update call control settings for a voice agent.\n\nConfigure whether the voice agent supports dial pad input, can end calls, and set a transfer phone number.\n\nFor compatibility this endpoint is also available using the following (deprecated) paths:\n`PUT \/v1\/agents\/{id}\/call-controls`',
    inputSchema: {
      pathParams: UpdateCallControlsParams,
      bodyParams: UpdateCallControlsBody.optional()
    },
    outputSchema: UpdateCallControlsResponse,
    annotations: { destructiveHint: true, idempotentHint: true },
  },
  (args, ctx) => updateCallControlsHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.scheduleJob = server.registerTool(
  'scheduleJob',
  {
    title: 'Schedule an outbound job',
    description: 'Schedule a new outbound call job for a voice agent.\n\nThe job can be scheduled for a future time or triggered immediately with `trigger_immediately: true`.\n\n\*\*Scheduling:\*\*\n\nWhen scheduling for a future time, provide `scheduled_at` (ISO 8601) and optionally `schedule_window_minutes` (minimum 10 minutes).\n\n\*\*Environment:\*\*\n\n`environment` selects which promoted agent configuration and phone binding the call dispatches against (`live` or `test`). Defaults to `live`. Scheduling fails when the selected environment has no active promotion.\n\nFor compatibility this endpoint is also available using the following (deprecated) paths:\n`POST \/v1\/agents\/{id}\/jobs`',
    inputSchema: {
      pathParams: ScheduleJobParams,
      bodyParams: ScheduleJobBody.optional()
    },
    outputSchema: ScheduleJobResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => scheduleJobHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listJobs = server.registerTool(
  'listJobs',
  {
    title: 'List outbound jobs',
    description: 'List all outbound jobs with pagination and filtering.\n\n\*\*Filtering:\*\*\n\n- Filter by agent ID, status, or scheduled time range.\n- Multiple statuses can be comma-separated (e.g. `status=pending,queued`).\n\nFor compatibility this endpoint is also available using the following (deprecated) paths:\n`GET \/v1\/agents\/jobs`',
    inputSchema: {
      queryParams: ListJobsQueryParams
    },
    outputSchema: ListJobsResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listJobsHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.cancelJob = server.registerTool(
  'cancelJob',
  {
    title: 'Cancel an outbound job',
    description: 'Cancel a pending or queued outbound job. Jobs that are already in progress or completed cannot be canceled.\n\nFor compatibility this endpoint is also available using the following (deprecated) paths:\n`POST \/v1\/agents\/jobs\/{id}\/cancel`',
    inputSchema: {
      pathParams: CancelJobParams
    },
    outputSchema: CancelJobResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => cancelJobHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listApiKeys = server.registerTool(
  'listApiKeys',
  {
    title: 'List API keys',
    description: 'List all API keys for your tenant.\n\nBy default, revoked keys are excluded. Set `include_revoked=true` to include them.\n\n\*\*Note:\*\* The full API key value is never returned — only the key prefix is shown.',
    inputSchema: {
      queryParams: ListApiKeysQueryParams
    },
    outputSchema: ListApiKeysResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listApiKeysHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.createApiKey = server.registerTool(
  'createApiKey',
  {
    title: 'Create an API key',
    description: 'Create a new API key for authenticating with the Avallon API.\n\n\*\*Important:\*\* The full API key is only returned once in the response. Store it securely — it cannot be retrieved again.\n\nKeys are scoped to an environment (`test` or `live`) and optionally accept an expiration date.',
    inputSchema: {
      bodyParams: CreateApiKeyBody.optional()
    },
    outputSchema: CreateApiKeyResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => createApiKeyHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.revokeApiKey = server.registerTool(
  'revokeApiKey',
  {
    title: 'Revoke an API key',
    description: 'Revoke an existing API key. Once revoked, the key can no longer be used for authentication.\n\nThis operation is irreversible — revoked keys cannot be re-enabled. Create a new key if needed.\n\nReturns 409 if the key is already revoked, 404 if the key does not exist.',
    inputSchema: {
      pathParams: RevokeApiKeyParams
    },
    outputSchema: RevokeApiKeyResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => revokeApiKeyHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.updateApiKey = server.registerTool(
  'updateApiKey',
  {
    title: 'Update API key',
    description: 'Update mutable fields of an API key. Currently only `role` can be updated.\n\nThe caller\'s role caps the maximum role they can grant — an `admin` cannot promote a key to `avallon_admin`.',
    inputSchema: {
      pathParams: UpdateApiKeyParams,
      bodyParams: UpdateApiKeyBody.optional()
    },
    outputSchema: UpdateApiKeyResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => updateApiKeyHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.createArtifact = server.registerTool(
  'createArtifact',
  {
    title: 'Create artifact',
    description: 'Upload a document as a base64-encoded artifact for processing.\n\n\*\*Limits:\*\*\n\nMaximum file size is approximately 6.75MB (base64 encoded). The API Gateway has a 10MB request limit.\n\n\*\*Processing options:\*\*\n\n- `file_password`: Password for encrypted PDFs\n- `file_splitting_enabled`: Split multi-page PDFs into separate artifacts',
    inputSchema: {
      bodyParams: CreateArtifactBody.optional()
    },
    outputSchema: CreateArtifactResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => createArtifactHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listArtifacts = server.registerTool(
  'listArtifacts',
  {
    title: 'List artifacts',
    description: 'List all artifacts with pagination, filtering, and sorting.\n\n\*\*Case Filtering:\*\*\n\nUse `case_id` to return only artifacts linked to a case. This reads the case links\ncreated via `POST \/v1\/cases\/{caseId}\/links`, and is independent of any\n`metadata.case_id` an artifact may carry.\n\n\*\*Metadata Filtering:\*\*\n\nUse bracket notation to filter by metadata keys:\n- `metadata[claim_id]=abc-123`\n- `metadata[source]=email`\n\nMultiple metadata filters can be combined (AND logic).',
    inputSchema: {
      queryParams: ListArtifactsQueryParams
    },
    outputSchema: ListArtifactsResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listArtifactsHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getArtifact = server.registerTool(
  'getArtifact',
  {
    title: 'Get artifact',
    description: 'Retrieve a single artifact by ID, including its metadata, file URL, extracted content, and chunk-annotated content.\n\nThe response always includes `content_with_chunkids_md`: the parsed content annotated with `[chunk_id=...]` markers when the artifact has parsed chunks. Chunk IDs are stable citation anchors — cite them to attribute extracted values to their source location.',
    inputSchema: {
      pathParams: GetArtifactParams
    },
    outputSchema: GetArtifactResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getArtifactHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.deleteArtifact = server.registerTool(
  'deleteArtifact',
  {
    title: 'Delete artifact',
    description: 'Soft-delete an artifact. Soft-deleted artifacts and their chunks no longer appear in any read.',
    inputSchema: {
      pathParams: DeleteArtifactParams
    },
    outputSchema: DeleteArtifactResponse,
    annotations: { destructiveHint: true, idempotentHint: true },
  },
  (args, ctx) => deleteArtifactHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getArtifactMetadataKeys = server.registerTool(
  'getArtifactMetadataKeys',
  {
    title: 'Get artifact metadata keys',
    description: 'Retrieve all unique metadata keys and their values across artifacts. Useful for building filter UIs.',
    inputSchema: {
      queryParams: GetArtifactMetadataKeysQueryParams
    },
    outputSchema: GetArtifactMetadataKeysResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getArtifactMetadataKeysHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getArtifactStatusSummary = server.registerTool(
  'getArtifactStatusSummary',
  {
    title: 'Get artifact status summary',
    description: 'Count the artifacts in a scope, broken down by processing status.\n\nDefine the scope with bracket notation (e.g. `scope[email_id]=abc-123`). At least one key is required; multiple keys are combined with AND logic.',
    inputSchema: {
      queryParams: GetArtifactStatusSummaryQueryParams
    },
    outputSchema: GetArtifactStatusSummaryResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getArtifactStatusSummaryHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getArtifactUploadUrl = server.registerTool(
  'getArtifactUploadUrl',
  {
    title: 'Request a pre-signed URL for direct large file upload',
    description: 'Returns a pre-signed PUT URL. Upload the file directly to `upload_url`, then pass `file_url` as `source_url` to POST \/v1\/upload-file.',
    inputSchema: {
      bodyParams: GetArtifactUploadUrlBody.optional()
    },
    outputSchema: GetArtifactUploadUrlResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => getArtifactUploadUrlHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.updateArtifactMetadata = server.registerTool(
  'updateArtifactMetadata',
  {
    title: 'Update artifact metadata',
    description: 'Merge-update metadata on an existing artifact. Provided keys are added or overwritten; other existing keys are preserved.',
    inputSchema: {
      pathParams: UpdateArtifactMetadataParams,
      bodyParams: UpdateArtifactMetadataBody.optional()
    },
    outputSchema: UpdateArtifactMetadataResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => updateArtifactMetadataHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.signUp = server.registerTool(
  'signUp',
  {
    title: 'Sign up',
    description: 'Create a new user account with email and password. When the response includes a pending_authentication_token, the account requires email verification: complete it via sign-in (type: email_otp) with the emailed one-time password and this token.',
    inputSchema: {
      bodyParams: SignUpBody.optional()
    },
    outputSchema: SignUpResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => signUpHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.signIn = server.registerTool(
  'signIn',
  {
    title: 'Sign in',
    description: 'Authenticate using one of the supported methods:\n\n- \*\*Password:\*\* Email and password credentials. If the password is correct but the email is not verified yet, responds 403 with `data.pending_authentication_token` and a fresh verification code is emailed; complete verification via \*\*Email OTP\*\*. Each password attempt invalidates earlier codes and tokens, so always use the most recent pair — repeating the password sign-in is also how a new code is requested.\n- \*\*OAuth:\*\* Authorization code from OAuth flow (social or enterprise SSO). Pass the `provider` the flow was started with so the code is exchanged against the system that issued it. `verifier` is only required when the flow was started with a `code_challenge` — see \*\*Get OAuth sign-in URL\*\*.\n- \*\*Email OTP:\*\* One-time password sent to email. Include the `pending_authentication_token` from sign-up, or from the 403 returned by an unverified user\'s password sign-in, when completing email verification.',
    inputSchema: {
      bodyParams: SignInBody.optional()
    },
    outputSchema: SignInResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => signInHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.requestPasswordReset = server.registerTool(
  'requestPasswordReset',
  {
    title: 'Request password reset',
    description: 'Start password recovery for an email\/password account. When the email belongs to an account, a reset link is emailed to it. The response is 200 regardless, and does not reveal whether an account exists.',
    inputSchema: {
      bodyParams: RequestPasswordResetBody.optional()
    },
    outputSchema: RequestPasswordResetResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => requestPasswordResetHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.resetPassword = server.registerTool(
  'resetPassword',
  {
    title: 'Reset password',
    description: 'Complete password recovery with the token from the emailed reset link and set a new password. Completing the reset also verifies the account\'s email address. Afterwards, sign in with the new password.',
    inputSchema: {
      bodyParams: ResetPasswordBody.optional()
    },
    outputSchema: ResetPasswordResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => resetPasswordHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.refreshToken = server.registerTool(
  'refreshToken',
  {
    title: 'Refresh authentication token',
    description: 'Exchange a valid access token and refresh token pair for new tokens.',
    inputSchema: {
      bodyParams: RefreshTokenBody.optional()
    },
    outputSchema: RefreshTokenResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => refreshTokenHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getOAuthUrl = server.registerTool(
  'getOAuthUrl',
  {
    title: 'Get OAuth sign-in URL',
    description: 'Generate an OAuth authorization URL for a given provider.\n\nPKCE is optional. To use it, generate a random verifier, derive `code_challenge` from it, and pass both `code_challenge` and the matching `code_challenge_method` — then send the verifier to \*\*Sign in\*\* when exchanging the code. Omit both to run the flow without PKCE and exchange the code on its own.\n\nFor enterprise SSO, pass `provider=sso` together with the user\'s `email`; the email domain selects the SSO organization. Responds 404 when no SSO organization is configured for the domain.',
    inputSchema: {
      queryParams: GetOAuthUrlQueryParams
    },
    outputSchema: GetOAuthUrlResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getOAuthUrlHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getSessionToken = server.registerTool(
  'getSessionToken',
  {
    title: 'Create or switch tenant session',
    description: 'Exchange an identity token for a tenant-scoped Core Plane access token.\n\n- If `tenant_id` is provided, validates the user is a member of that tenant and returns 404 if they are not.\n- If `tenant_id` is omitted, selects the tenant of the identity token\'s organization, falling back to the user\'s default (oldest) tenant.\n- Call this endpoint again with a different `tenant_id` to switch tenants.',
    inputSchema: {
      bodyParams: GetSessionTokenBody.optional()
    },
    outputSchema: GetSessionTokenResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => getSessionTokenHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getPartnerJwks = server.registerTool(
  'getPartnerJwks',
  {
    title: 'Get partner JWKS',
    description: 'Returns the JSON Web Key Set (RFC 7517) of a partner\'s public signing keys, used to verify partner-issued launch tokens.',
    inputSchema: {
      pathParams: GetPartnerJwksParams
    },
    outputSchema: GetPartnerJwksResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getPartnerJwksHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.partnerLaunch = server.registerTool(
  'partnerLaunch',
  {
    title: 'Partner launch (SSO)',
    description: 'Verifies a partner-signed launch token, mints an Avallon session, and redirects (302) the user into the app\'s handoff route, carrying the session token in the URL fragment (no cookie).',
    inputSchema: {
      queryParams: PartnerLaunchQueryParams
    },
    outputSchema: PartnerLaunchResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => partnerLaunchHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listCalls = server.registerTool(
  'listCalls',
  {
    title: 'List calls',
    description: 'List all calls, with pagination, filtering, and sorting.\n\n\*\*Filtering:\*\*\n\nFilter by agent, direction, status, time range, phone number, and more. Phone number filter supports both exact E.164 matches and partial search.\n\n\*\*Case Filtering:\*\*\n\nUse `case_id` to return only calls linked to a case. This reads the case links created\nvia `POST \/v1\/cases\/{caseId}\/links`, and is independent of any `metadata.case_id` a\ncall may carry.\n\n\*\*Metadata Filtering:\*\*\n\nUse bracket notation to filter by metadata keys:\n- `metadata[claim_id]=abc-123`\n- `metadata[source]=worker`\n\nMultiple metadata filters can be combined (AND logic).',
    inputSchema: {
      queryParams: ListCallsQueryParams
    },
    outputSchema: ListCallsResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listCallsHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getCall = server.registerTool(
  'getCall',
  {
    title: 'Get call',
    description: 'Retrieve detailed information about a specific call.\n\nSet `include_messages=true` to include the full message transcript.',
    inputSchema: {
      pathParams: GetCallParams,
      queryParams: GetCallQueryParams
    },
    outputSchema: GetCallResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getCallHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getCallEvaluation = server.registerTool(
  'getCallEvaluation',
  {
    title: 'Get call evaluation',
    description: 'Retrieve the evaluation results for a specific call, including overall score, pass status, and per-metric breakdowns.',
    inputSchema: {
      pathParams: GetCallEvaluationParams
    },
    outputSchema: GetCallEvaluationResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getCallEvaluationHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getCallAnalytics = server.registerTool(
  'getCallAnalytics',
  {
    title: 'Get call analytics',
    description: 'Retrieve aggregated call analytics for a time range.\n\nIncludes summary statistics, call volume over time, evaluation scores, score and duration distributions, and per-metric performance.',
    inputSchema: {
      queryParams: GetCallAnalyticsQueryParams
    },
    outputSchema: GetCallAnalyticsResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getCallAnalyticsHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getAnalyticsTimeSeries = server.registerTool(
  'getAnalyticsTimeSeries',
  {
    title: 'Get analytics time series',
    description: 'Retrieve a tenant-scoped time series for a single processing-volume metric.\n\nPick a `metric` (worker runs, documents, or pages), a date range, a bucket `granularity` (day\/week\/month), and optionally a `group_by` dimension (e.g. worker runs grouped by worker). The series is sparse (only buckets with data) over the half-open window `[from, to)`.\n\n`data` is an array of per-metric results; today it always contains exactly one entry (the requested metric).',
    inputSchema: {
      queryParams: GetAnalyticsTimeSeriesQueryParams
    },
    outputSchema: GetAnalyticsTimeSeriesResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getAnalyticsTimeSeriesHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.createCallFeedback = server.registerTool(
  'createCallFeedback',
  {
    title: 'Create feedback on a call message',
    description: 'Create feedback for a specific message in a call. Requires user (JWT) authentication; the author is derived from the authenticated user\'s profile and API-key callers are rejected.',
    inputSchema: {
      pathParams: CreateCallFeedbackParams,
      bodyParams: CreateCallFeedbackBody.optional()
    },
    outputSchema: CreateCallFeedbackResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => createCallFeedbackHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listCallFeedback = server.registerTool(
  'listCallFeedback',
  {
    title: 'List feedback for a call',
    description: 'List all feedback for a call. Paginated.',
    inputSchema: {
      pathParams: ListCallFeedbackParams,
      queryParams: ListCallFeedbackQueryParams
    },
    outputSchema: ListCallFeedbackResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listCallFeedbackHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.deleteCallFeedback = server.registerTool(
  'deleteCallFeedback',
  {
    title: 'Delete feedback',
    description: 'Delete a single feedback entry.',
    inputSchema: {
      pathParams: DeleteCallFeedbackParams
    },
    outputSchema: DeleteCallFeedbackResponse,
    annotations: { destructiveHint: true, idempotentHint: true },
  },
  (args, ctx) => deleteCallFeedbackHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.checkInboxAvailability = server.registerTool(
  'checkInboxAvailability',
  {
    title: 'Check email username availability',
    description: 'Check whether a given email username is available for creating a new inbox.\n\nFor compatibility this endpoint is also available using the following (deprecated) paths:\n`GET \/v1\/email-agents\/availability`',
    inputSchema: {
      queryParams: CheckInboxAvailabilityQueryParams
    },
    outputSchema: CheckInboxAvailabilityResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => checkInboxAvailabilityHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.createInbox = server.registerTool(
  'createInbox',
  {
    title: 'Create inbox',
    description: 'Create a new inbox linked to a processor (extractor or worker).\n\nThe inbox will receive emails at the assigned address and automatically process attachments using the specified processor.\n\nEither `processor_id` or the deprecated `extractor_id` must be provided. When using `extractor_id`, the processor type defaults to `extractor`.\n\nFor compatibility this endpoint is also available using the following (deprecated) paths:\n`POST \/v1\/email-agents`',
    inputSchema: {
      bodyParams: CreateInboxBody.optional()
    },
    outputSchema: CreateInboxResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => createInboxHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listInboxes = server.registerTool(
  'listInboxes',
  {
    title: 'List inboxes',
    description: 'List all inboxes with pagination and sorting.\n\nFor compatibility this endpoint is also available using the following (deprecated) paths:\n`GET \/v1\/email-agents`',
    inputSchema: {
      queryParams: ListInboxesQueryParams
    },
    outputSchema: ListInboxesResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listInboxesHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.updateInbox = server.registerTool(
  'updateInbox',
  {
    title: 'Update inbox',
    description: 'Update an inbox\'s configuration.\n\nFor compatibility this endpoint is also available using the following (deprecated) paths:\n`PATCH \/v1\/email-agents\/{id}`',
    inputSchema: {
      pathParams: UpdateInboxParams,
      bodyParams: UpdateInboxBody.optional()
    },
    outputSchema: UpdateInboxResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => updateInboxHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.deleteInbox = server.registerTool(
  'deleteInbox',
  {
    title: 'Delete inbox',
    description: 'Delete an inbox. The inbox stops routing new mail; existing email history is preserved.',
    inputSchema: {
      pathParams: DeleteInboxParams
    },
    outputSchema: DeleteInboxResponse,
    annotations: { destructiveHint: true, idempotentHint: true },
  },
  (args, ctx) => deleteInboxHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getEmail = server.registerTool(
  'getEmail',
  {
    title: 'Get email',
    description: 'Retrieve detailed information about a specific email, including full body content.',
    inputSchema: {
      pathParams: GetEmailParams
    },
    outputSchema: GetEmailResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getEmailHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.deleteEmail = server.registerTool(
  'deleteEmail',
  {
    title: 'Delete email',
    description: 'Soft-delete an email. The message is hidden from all reads (get, list, and thread aggregation) but its content is retained until a separate hard purge.',
    inputSchema: {
      pathParams: DeleteEmailParams
    },
    outputSchema: DeleteEmailResponse,
    annotations: { destructiveHint: true, idempotentHint: true },
  },
  (args, ctx) => deleteEmailHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listEmails = server.registerTool(
  'listEmails',
  {
    title: 'List emails',
    description: 'List all emails with pagination and filtering.\n\n\*\*Filtering:\*\*\n\nFilter by email agent, sender, recipient, content search, or case.',
    inputSchema: {
      queryParams: ListEmailsQueryParams
    },
    outputSchema: ListEmailsResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listEmailsHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listEmailThreads = server.registerTool(
  'listEmailThreads',
  {
    title: 'List email threads',
    description: 'List email threads with pagination. Each thread includes the subject of the first email, the sender of the first email, and the date of the last email.\n\n\*\*Filtering:\*\*\n\nFilter by inbox or environment. Without an `environment` filter, live and test threads are returned together.',
    inputSchema: {
      queryParams: ListEmailThreadsQueryParams
    },
    outputSchema: ListEmailThreadsResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listEmailThreadsHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.replyToEmail = server.registerTool(
  'replyToEmail',
  {
    title: 'Reply to email',
    description: 'Reply to an existing email thread via Nylas. The reply is sent to the original sender by default.\n\nOptionally include additional recipients via `to` (merged with the original sender), `cc`, and `bcc` arrays.\n\nThe `body` is HTML by default. Set `is_html` to `false` to provide plain text instead; it is converted to HTML before sending.',
    inputSchema: {
      pathParams: ReplyToEmailParams,
      bodyParams: ReplyToEmailBody.optional()
    },
    outputSchema: ReplyToEmailResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => replyToEmailHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.sendEmail = server.registerTool(
  'sendEmail',
  {
    title: 'Send email',
    description: 'Send a new email through an inbox. The provider-assigned thread id is returned and persisted on the stored email row, so subsequent inbound replies on that thread are linked to this send.\n\nThe `body` is HTML by default. Set `is_html` to `false` to provide plain text instead; it is converted to HTML before sending.',
    inputSchema: {
      bodyParams: SendEmailBody.optional()
    },
    outputSchema: SendEmailResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => sendEmailHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listExtractorJobs = server.registerTool(
  'listExtractorJobs',
  {
    title: 'List extractor jobs',
    description: 'List all extraction jobs with pagination, filtering, and sorting.\n\n\*\*Scope Filtering:\*\*\n\nUse bracket notation to filter by scope keys:\n- `scope[call_id]=abc-123`\n- `scope[email_id]=xyz-456`\n- `scope[case_id]=case-789`\n\nMultiple scope filters can be combined (AND logic).',
    inputSchema: {
      queryParams: ListExtractorJobsQueryParams
    },
    outputSchema: ListExtractorJobsResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listExtractorJobsHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.createExtractorJob = server.registerTool(
  'createExtractorJob',
  {
    title: 'Create extractor job',
    description: 'Create a new extraction job for the specified extractor.\n\nProvide a non-empty `scope` object to define what the extractor should process (e.g. `{ \"claim_id\": \"abc-123\" }`).',
    inputSchema: {
      bodyParams: CreateExtractorJobBody.optional()
    },
    outputSchema: CreateExtractorJobResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => createExtractorJobHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getExtractorJob = server.registerTool(
  'getExtractorJob',
  {
    title: 'Get extractor job',
    description: 'Retrieve detailed information about a specific extractor job, including its status, timing, and result.',
    inputSchema: {
      pathParams: GetExtractorJobParams
    },
    outputSchema: GetExtractorJobResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getExtractorJobHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listWorkerRuns = server.registerTool(
  'listWorkerRuns',
  {
    title: 'List worker runs',
    description: 'List all worker runs with pagination, filtering, and sorting.\n\n\*\*Scope Filtering:\*\*\n\nUse bracket notation to filter by scope keys:\n- `scope[call_id]=abc-123`\n- `scope[email_id]=xyz-456`\n\nMultiple scope filters can be combined (AND logic).',
    inputSchema: {
      queryParams: ListWorkerRunsQueryParams
    },
    outputSchema: ListWorkerRunsResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listWorkerRunsHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.createWorkerRun = server.registerTool(
  'createWorkerRun',
  {
    title: 'Create worker run',
    description: 'Create a new worker run for the specified worker.\n\nProvide a `scope` object with at least one key to define which artifacts the worker should process (e.g. `{ \"claim_id\": \"abc-123\" }`). The run stays `pending` until those artifacts are ready.\n\nPass `null` to run the worker without any artifacts — the run is queued immediately. An empty object is rejected.',
    inputSchema: {
      bodyParams: CreateWorkerRunBody.optional()
    },
    outputSchema: CreateWorkerRunResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => createWorkerRunHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getWorkerRun = server.registerTool(
  'getWorkerRun',
  {
    title: 'Get worker run',
    description: 'Retrieve detailed information about a specific worker run, including its status, timing, and errors.',
    inputSchema: {
      pathParams: GetWorkerRunParams
    },
    outputSchema: GetWorkerRunResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getWorkerRunHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listWorkerRunMessages = server.registerTool(
  'listWorkerRunMessages',
  {
    title: 'List worker run messages',
    description: 'Retrieve messages emitted during a worker run, ordered by emission time. Supports cursor-style pagination via `after` and `count`.',
    inputSchema: {
      pathParams: ListWorkerRunMessagesParams,
      queryParams: ListWorkerRunMessagesQueryParams
    },
    outputSchema: ListWorkerRunMessagesResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listWorkerRunMessagesHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.cancelWorkerRun = server.registerTool(
  'cancelWorkerRun',
  {
    title: 'Cancel a worker run',
    description: 'Cancel a worker run. For in_progress runs, the underlying E2B sandbox is terminated when possible. Pending and queued runs are simply marked canceled. Runs that are starting are still being handed their context and cannot be interrupted, so they cannot be canceled until they reach in_progress. Runs in terminal states (completed, failed) cannot be canceled. Already-canceled runs are returned without side effects.',
    inputSchema: {
      pathParams: CancelWorkerRunParams
    },
    outputSchema: CancelWorkerRunResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => cancelWorkerRunHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.createWorkerEvalFromRun = server.registerTool(
  'createWorkerEvalFromRun',
  {
    title: 'Create a worker eval from a run',
    description: 'Snapshot a worker run\'s trigger and resolved artifacts. Mock responses are returned in call order.',
    inputSchema: {
      pathParams: CreateWorkerEvalFromRunParams,
      bodyParams: CreateWorkerEvalFromRunBody.optional()
    },
    outputSchema: CreateWorkerEvalFromRunResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => createWorkerEvalFromRunHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.runEval = server.registerTool(
  'runEval',
  {
    title: 'Run an eval',
    description: 'Queue the worker\'s current test version against the eval\'s immutable artifact snapshot and mocked tools.',
    inputSchema: {
      pathParams: RunEvalParams
    },
    outputSchema: RunEvalResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => runEvalHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getEvalRun = server.registerTool(
  'getEvalRun',
  {
    title: 'Get an eval run',
    description: 'Get the status and prompt-grader result for an eval run.',
    inputSchema: {
      pathParams: GetEvalRunParams
    },
    outputSchema: GetEvalRunResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getEvalRunHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.createExtractor = server.registerTool(
  'createExtractor',
  {
    title: 'Create extractor',
    description: 'Create a new extractor with a name and JSON schema defining the extraction output format.',
    inputSchema: {
      bodyParams: CreateExtractorBody.optional()
    },
    outputSchema: CreateExtractorResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => createExtractorHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listExtractors = server.registerTool(
  'listExtractors',
  {
    title: 'List extractors',
    description: 'List all extractors with pagination, filtering, and sorting.\n\nFilter by name using the `name` query parameter.',
    inputSchema: {
      queryParams: ListExtractorsQueryParams
    },
    outputSchema: ListExtractorsResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listExtractorsHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getExtractor = server.registerTool(
  'getExtractor',
  {
    title: 'Get extractor',
    description: 'Retrieve a single extractor by ID, including its schema and version.',
    inputSchema: {
      pathParams: GetExtractorParams
    },
    outputSchema: GetExtractorResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getExtractorHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.updateExtractor = server.registerTool(
  'updateExtractor',
  {
    title: 'Update extractor',
    description: 'Update an extractor\'s schema. This creates a new version of the extractor.',
    inputSchema: {
      pathParams: UpdateExtractorParams,
      bodyParams: UpdateExtractorBody.optional()
    },
    outputSchema: UpdateExtractorResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => updateExtractorHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.deleteExtractor = server.registerTool(
  'deleteExtractor',
  {
    title: 'Delete extractor',
    description: 'Soft-delete an extractor and all of its versions. Soft-deleted extractors no longer appear in any read.',
    inputSchema: {
      pathParams: DeleteExtractorParams
    },
    outputSchema: DeleteExtractorResponse,
    annotations: { destructiveHint: true, idempotentHint: true },
  },
  (args, ctx) => deleteExtractorHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.createWorker = server.registerTool(
  'createWorker',
  {
    title: 'Create worker',
    description: 'Create a new worker with a name and prompt.',
    inputSchema: {
      bodyParams: CreateWorkerBody.optional()
    },
    outputSchema: CreateWorkerResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => createWorkerHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listWorkers = server.registerTool(
  'listWorkers',
  {
    title: 'List workers',
    description: 'List all workers with pagination, filtering, and sorting.\n\nFilter by name using the `name` query parameter.',
    inputSchema: {
      queryParams: ListWorkersQueryParams
    },
    outputSchema: ListWorkersResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listWorkersHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getWorker = server.registerTool(
  'getWorker',
  {
    title: 'Get worker',
    description: 'Retrieve a single worker by ID.',
    inputSchema: {
      pathParams: GetWorkerParams
    },
    outputSchema: GetWorkerResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getWorkerHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.deleteWorker = server.registerTool(
  'deleteWorker',
  {
    title: 'Delete worker',
    description: 'Delete a worker. The worker is hidden from all reads; its run history is preserved.',
    inputSchema: {
      pathParams: DeleteWorkerParams
    },
    outputSchema: DeleteWorkerResponse,
    annotations: { destructiveHint: true, idempotentHint: true },
  },
  (args, ctx) => deleteWorkerHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.updateWorker = server.registerTool(
  'updateWorker',
  {
    title: 'Update worker',
    description: 'Update the configuration of a worker, including the attached tool set.',
    inputSchema: {
      pathParams: UpdateWorkerParams,
      bodyParams: UpdateWorkerBody.optional()
    },
    outputSchema: UpdateWorkerResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => updateWorkerHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getWorkerPrompt = server.registerTool(
  'getWorkerPrompt',
  {
    title: 'Get worker prompt',
    description: 'Retrieve the prompt for a worker. Pass `version` to fetch the prompt snapshot at a specific config version; omit it to fetch the current prompt. Internal use only.',
    inputSchema: {
      pathParams: GetWorkerPromptParams,
      queryParams: GetWorkerPromptQueryParams
    },
    outputSchema: GetWorkerPromptResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getWorkerPromptHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.updateWorkerPrompt = server.registerTool(
  'updateWorkerPrompt',
  {
    title: 'Update worker prompt',
    description: 'Update the prompt for a worker. Internal use only.',
    inputSchema: {
      pathParams: UpdateWorkerPromptParams,
      bodyParams: UpdateWorkerPromptBody.optional()
    },
    outputSchema: UpdateWorkerPromptResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => updateWorkerPromptHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listWorkerModels = server.registerTool(
  'listWorkerModels',
  {
    title: 'List available worker models',
    description: 'List the LLM models that can be assigned to a worker via the `model` field on update.',
    outputSchema: ListWorkerModelsResponse,
    annotations: { readOnlyHint: true },
  },
  (ctx) => listWorkerModelsHandler({
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.updateWorkerMcps = server.registerTool(
  'updateWorkerMcps',
  {
    title: 'Update worker MCP servers',
    description: 'Replace the set of MCP servers a worker connects to. Pass an empty array to disconnect.',
    inputSchema: {
      pathParams: UpdateWorkerMcpsParams,
      bodyParams: UpdateWorkerMcpsBody.optional()
    },
    outputSchema: UpdateWorkerMcpsResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => updateWorkerMcpsHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listWorkerVersions = server.registerTool(
  'listWorkerVersions',
  {
    title: 'List worker versions',
    description: 'List all config versions for a worker, ordered by version (newest first by default).',
    inputSchema: {
      pathParams: ListWorkerVersionsParams,
      queryParams: ListWorkerVersionsQueryParams
    },
    outputSchema: ListWorkerVersionsResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listWorkerVersionsHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getWorkerVersion = server.registerTool(
  'getWorkerVersion',
  {
    title: 'Get worker version',
    description: 'Retrieve a single worker config version, including the worker\'s identity, the config snapshot at that version, and version-specific metadata. The prompt is served separately by the worker prompt endpoint.',
    inputSchema: {
      pathParams: GetWorkerVersionParams
    },
    outputSchema: GetWorkerVersionResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getWorkerVersionHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.promoteWorkerVersion = server.registerTool(
  'promoteWorkerVersion',
  {
    title: 'Promote worker version',
    description: 'Select a worker configuration version for the live or test environment. This freezes the config snapshot only — the E2B template, attached tools and attached secrets are not versioned and always resolve to their current values.',
    inputSchema: {
      pathParams: PromoteWorkerVersionParams,
      bodyParams: PromoteWorkerVersionBody.optional()
    },
    outputSchema: PromoteWorkerVersionResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => promoteWorkerVersionHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getWorkerVersionChangeSummary = server.registerTool(
  'getWorkerVersionChangeSummary',
  {
    title: 'Get worker version change summary',
    description: 'Returns an AI-generated summary of what changed between this version and the previous one. Initial version returns an empty string since there is no predecessor.',
    inputSchema: {
      pathParams: GetWorkerVersionChangeSummaryParams
    },
    outputSchema: GetWorkerVersionChangeSummaryResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getWorkerVersionChangeSummaryHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.createWorkerWebhook = server.registerTool(
  'createWorkerWebhook',
  {
    title: 'Create worker webhook',
    description: 'Create a webhook that fires when events occur for the specified worker.',
    inputSchema: {
      pathParams: CreateWorkerWebhookParams,
      bodyParams: CreateWorkerWebhookBody.optional()
    },
    outputSchema: CreateWorkerWebhookResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => createWorkerWebhookHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listWorkerWebhooks = server.registerTool(
  'listWorkerWebhooks',
  {
    title: 'List worker webhooks',
    description: 'List all webhooks configured for a specific worker.',
    inputSchema: {
      pathParams: ListWorkerWebhooksParams,
      queryParams: ListWorkerWebhooksQueryParams
    },
    outputSchema: ListWorkerWebhooksResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listWorkerWebhooksHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listCases = server.registerTool(
  'listCases',
  {
    title: 'List cases',
    description: 'List all cases for the current tenant, paginated, filterable, and sortable.',
    inputSchema: {
      queryParams: ListCasesQueryParams
    },
    outputSchema: ListCasesResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listCasesHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.createCase = server.registerTool(
  'createCase',
  {
    title: 'Create case',
    description: 'Create a case with a client-supplied id.\n\nCase ids are tenant-scoped opaque keys (e.g. \"clm-1\", \"STD-001\") and are normalized server-side (trimmed and lowercased). Creating an id that already exists \*\*in the same environment\*\* returns 409 — the same id can exist once in `live` and once in `test`.',
    inputSchema: {
      bodyParams: CreateCaseBody.optional()
    },
    outputSchema: CreateCaseResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => createCaseHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.searchCases = server.registerTool(
  'searchCases',
  {
    title: 'Search cases',
    description: 'Probe for candidate cases. Matches the query as a normalized substring of the case id, and fuzzily (trigram) against subject and reporter. Results are relevance-ranked — id matches first, then best fuzzy match, then most recently updated — so ordering is fixed and not configurable.',
    inputSchema: {
      queryParams: SearchCasesQueryParams
    },
    outputSchema: SearchCasesResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => searchCasesHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getCase = server.registerTool(
  'getCase',
  {
    title: 'Get case',
    description: 'Retrieve a case by id.\n\nRelated entities are not embedded — fetch them via the filtered list endpoints,\ne.g. `GET \/v1\/worker-runs?case_id=…` and `GET \/v1\/artifacts?metadata[case_id]=…`.',
    inputSchema: {
      pathParams: GetCaseParams,
      queryParams: GetCaseQueryParams
    },
    outputSchema: GetCaseResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getCaseHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.addCaseLinks = server.registerTool(
  'addCaseLinks',
  {
    title: 'Add case links',
    description: 'Link one or more entities (artifacts, calls, chats, emails, extracts, information requests, schedules, worker runs) to a case.\n\nThe case and every entity must already exist in the tenant — unknown ids return 404 and nothing is created. Adding is idempotent: re-linking an already linked entity returns the existing link with its original `created_at`.',
    inputSchema: {
      pathParams: AddCaseLinksParams,
      queryParams: AddCaseLinksQueryParams,
      bodyParams: AddCaseLinksBody.optional()
    },
    outputSchema: AddCaseLinksResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => addCaseLinksHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listCaseLinks = server.registerTool(
  'listCaseLinks',
  {
    title: 'List case links',
    description: 'List the entities linked to a case, paginated and filterable by entity type.',
    inputSchema: {
      pathParams: ListCaseLinksParams,
      queryParams: ListCaseLinksQueryParams
    },
    outputSchema: ListCaseLinksResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listCaseLinksHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.removeCaseLink = server.registerTool(
  'removeCaseLink',
  {
    title: 'Remove case link',
    description: 'Remove the link between a case and an entity. Removal is idempotent: removing a link that does not exist succeeds without effect.',
    inputSchema: {
      pathParams: RemoveCaseLinkParams,
      queryParams: RemoveCaseLinkQueryParams
    },
    outputSchema: RemoveCaseLinkResponse,
    annotations: { destructiveHint: true, idempotentHint: true },
  },
  (args, ctx) => removeCaseLinkHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.createChatAgent = server.registerTool(
  'createChatAgent',
  {
    title: 'Create chat agent',
    description: 'Create a new chat agent with a name and prompt.',
    inputSchema: {
      bodyParams: CreateChatAgentBody.optional()
    },
    outputSchema: CreateChatAgentResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => createChatAgentHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listChatAgents = server.registerTool(
  'listChatAgents',
  {
    title: 'List chat agents',
    description: 'List the tenant\'s chat agents with pagination and sorting. Prompts are not returned.',
    inputSchema: {
      queryParams: ListChatAgentsQueryParams
    },
    outputSchema: ListChatAgentsResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listChatAgentsHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getChatAgent = server.registerTool(
  'getChatAgent',
  {
    title: 'Get chat agent',
    description: 'Retrieve a single chat agent by ID, including the IDs of its attached code tools. The prompt is not returned.',
    inputSchema: {
      pathParams: GetChatAgentParams
    },
    outputSchema: GetChatAgentResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getChatAgentHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.updateChatAgent = server.registerTool(
  'updateChatAgent',
  {
    title: 'Update chat agent',
    description: 'Patch a chat agent\'s settings. Today only the attached code tool set can be edited; future fields will be added under the same endpoint. The response returns the chat agent\'s metadata only and does not include the resulting tool list; the agent\'s `updated_at` is not bumped when only the tool set changes.',
    inputSchema: {
      pathParams: UpdateChatAgentParams,
      bodyParams: UpdateChatAgentBody.optional()
    },
    outputSchema: UpdateChatAgentResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => updateChatAgentHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.deleteChatAgent = server.registerTool(
  'deleteChatAgent',
  {
    title: 'Delete chat agent',
    description: 'Soft-delete a chat agent. The agent no longer appears in any read and stops accepting new chats; existing chats and messages are preserved.',
    inputSchema: {
      pathParams: DeleteChatAgentParams
    },
    outputSchema: DeleteChatAgentResponse,
    annotations: { destructiveHint: true, idempotentHint: true },
  },
  (args, ctx) => deleteChatAgentHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getChatAgentPrompt = server.registerTool(
  'getChatAgentPrompt',
  {
    title: 'Get chat agent prompt',
    description: 'Retrieve the prompt and greeting for a chat agent. Internal use only.',
    inputSchema: {
      pathParams: GetChatAgentPromptParams
    },
    outputSchema: GetChatAgentPromptResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getChatAgentPromptHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.updateChatAgentPrompt = server.registerTool(
  'updateChatAgentPrompt',
  {
    title: 'Update chat agent prompt',
    description: 'Update the prompt and\/or greeting for a chat agent. Internal use only.',
    inputSchema: {
      pathParams: UpdateChatAgentPromptParams,
      bodyParams: UpdateChatAgentPromptBody.optional()
    },
    outputSchema: UpdateChatAgentPromptResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => updateChatAgentPromptHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.createChat = server.registerTool(
  'createChat',
  {
    title: 'Create a chat',
    description: 'Create a new chat against an existing chat agent. The chat agent\'s tenant becomes the owner of the chat.',
    inputSchema: {
      bodyParams: CreateChatBody.optional()
    },
    outputSchema: CreateChatResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => createChatHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getChat = server.registerTool(
  'getChat',
  {
    title: 'Get a chat',
    description: 'Return a chat and its messages in chronological order. Used to re-render a transcript after a reload. Only `user` and `assistant` messages are included; tool calls and tool results are omitted. Each message\'s `content` is the concatenation of its text blocks separated by newlines.\n\nFor compatibility this endpoint is also available using the following (deprecated) paths:\n`GET \/public\/v1\/chat`',
    inputSchema: {
      pathParams: GetChatParams
    },
    outputSchema: GetChatResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getChatHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getPublicChatAgent = server.registerTool(
  'getPublicChatAgent',
  {
    title: 'Get a chat agent (public)',
    description: 'Return the public-facing fields of a chat agent for use in the chat UI. Sensitive fields such as the agent\'s prompt and tenant ID are not exposed.',
    inputSchema: {
      pathParams: GetPublicChatAgentParams
    },
    outputSchema: GetPublicChatAgentResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getPublicChatAgentHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.postChatMessage = server.registerTool(
  'postChatMessage',
  {
    title: 'Post a message to a chat',
    description: 'Post a user message to an existing chat and return the assistant reply. Both messages are persisted.\n\nFor compatibility this endpoint is also available using the following (deprecated) paths:\n`POST \/public\/v1\/chat\/messages`',
    inputSchema: {
      pathParams: PostChatMessageParams,
      bodyParams: PostChatMessageBody.optional()
    },
    outputSchema: PostChatMessageResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => postChatMessageHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listChats = server.registerTool(
  'listChats',
  {
    title: 'List chats',
    description: 'List the tenant\'s chats with pagination, sorting, and optional filtering by case. Returns chat metadata and message counts; messages are not included.',
    inputSchema: {
      queryParams: ListChatsQueryParams
    },
    outputSchema: ListChatsResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listChatsHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listChatMessages = server.registerTool(
  'listChatMessages',
  {
    title: 'List chat messages',
    description: 'List messages for a chat owned by the tenant, in chronological order by default.',
    inputSchema: {
      pathParams: ListChatMessagesParams,
      queryParams: ListChatMessagesQueryParams
    },
    outputSchema: ListChatMessagesResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listChatMessagesHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getExtract = server.registerTool(
  'getExtract',
  {
    title: 'Get extract',
    description: 'Retrieve a single extract by ID, including the extraction result data.',
    inputSchema: {
      pathParams: GetExtractParams
    },
    outputSchema: GetExtractResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getExtractHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getExtractCitations = server.registerTool(
  'getExtractCitations',
  {
    title: 'Get extract citations',
    description: 'Retrieve the citation tree with resolved chunk data for a given extract. Returns 404 if the extract does not exist or has no citations (the citations sub-resource is not available).',
    inputSchema: {
      pathParams: GetExtractCitationsParams
    },
    outputSchema: GetExtractCitationsResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getExtractCitationsHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listExtracts = server.registerTool(
  'listExtracts',
  {
    title: 'List extracts',
    description: 'List all extracts with pagination, filtering, and sorting.\n\n\*\*Scope Filtering:\*\*\n\nUse bracket notation to filter by scope keys:\n- `scope[claim_id]=abc-123`\n\nMultiple scope filters can be combined (AND logic).',
    inputSchema: {
      queryParams: ListExtractsQueryParams
    },
    outputSchema: ListExtractsResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listExtractsHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getProfile = server.registerTool(
  'getProfile',
  {
    title: 'Get profile',
    description: 'Retrieve the current user\'s profile information. This endpoint requires a user session and cannot be used with API Keys.',
    outputSchema: GetProfileResponse,
    annotations: { readOnlyHint: true },
  },
  (ctx) => getProfileHandler({
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listTeamMembers = server.registerTool(
  'listTeamMembers',
  {
    title: 'List team members',
    description: 'List all members in the current tenant.',
    outputSchema: ListTeamMembersResponse,
    annotations: { readOnlyHint: true },
  },
  (ctx) => listTeamMembersHandler({
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.inviteTeamMember = server.registerTool(
  'inviteTeamMember',
  {
    title: 'Invite a team member',
    description: 'Invite an email address to join the current tenant. The invitee receives an email and joins at the `member` role once they accept; promote them afterwards with `PATCH \/v1\/team\/members\/{id}`.\n\nRequires the `teams:write` permission.\n\nReturns `409` if the address already has a pending invitation or is already a member.',
    inputSchema: {
      bodyParams: InviteTeamMemberBody.optional()
    },
    outputSchema: InviteTeamMemberResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => inviteTeamMemberHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listTeamInvitations = server.registerTool(
  'listTeamInvitations',
  {
    title: 'List pending team invitations',
    description: 'List the invitations for the current tenant that are still awaiting acceptance. Accepted, revoked and expired invitations are not returned.\n\nInvitees are not team members yet, so they do not appear in `GET \/v1\/team\/members`. A member-management screen shows both by merging the two lists.\n\nRequires the `teams:write` permission.',
    outputSchema: ListTeamInvitationsResponse,
    annotations: { readOnlyHint: true },
  },
  (ctx) => listTeamInvitationsHandler({
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.revokeTeamInvitation = server.registerTool(
  'revokeTeamInvitation',
  {
    title: 'Revoke a team invitation',
    description: 'Cancel a pending invitation. The link that was emailed to the invitee stops working, and the address becomes free to invite again.\n\nIdempotent: an invitation that was already accepted, revoked or expired also returns `204`.\n\nRequires the `teams:write` permission.\n\nReturns `404` for an unknown invitation or one that belongs to another tenant.',
    inputSchema: {
      pathParams: RevokeTeamInvitationParams
    },
    outputSchema: RevokeTeamInvitationResponse,
    annotations: { destructiveHint: true, idempotentHint: true },
  },
  (args, ctx) => revokeTeamInvitationHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.resendTeamInvitation = server.registerTool(
  'resendTeamInvitation',
  {
    title: 'Resend a team invitation',
    description: 'Email the invitation to its recipient again, for an invite that never arrived. The invitation keeps its `id` and its original expiry — this re-sends the existing link rather than issuing a new one.\n\nTo give someone a genuinely fresh 5 days, revoke the invitation and send a new one instead.\n\nRequires the `teams:write` permission.\n\nReturns `409` if the invitation is no longer pending — it was accepted, revoked or expired underneath the caller — and `404` for an unknown invitation or one that belongs to another tenant.',
    inputSchema: {
      pathParams: ResendTeamInvitationParams
    },
    outputSchema: ResendTeamInvitationResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => resendTeamInvitationHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.updateMemberRole = server.registerTool(
  'updateMemberRole',
  {
    title: 'Update member role',
    description: 'Change the role of a team member.',
    inputSchema: {
      pathParams: UpdateMemberRoleParams,
      bodyParams: UpdateMemberRoleBody.optional()
    },
    outputSchema: UpdateMemberRoleResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => updateMemberRoleHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.removeMember = server.registerTool(
  'removeMember',
  {
    title: 'Remove team member',
    description: 'Soft-delete a team member, revoking access on the next token refresh.',
    inputSchema: {
      pathParams: RemoveMemberParams
    },
    outputSchema: RemoveMemberResponse,
    annotations: { destructiveHint: true, idempotentHint: true },
  },
  (args, ctx) => removeMemberHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.createSecret = server.registerTool(
  'createSecret',
  {
    title: 'Create a secret',
    description: 'Create an organization-level secret. The value is encrypted at rest and \*\*write-only\*\* — no endpoint ever returns it.\n\nRequires the `secrets:write` permission. Env keys used by the worker runtime itself (e.g. `OPENAI_API_KEY`, `AVALLON_\*`, `AWS_\*`) are reserved and rejected.',
    inputSchema: {
      bodyParams: CreateSecretBody.optional()
    },
    outputSchema: CreateSecretResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => createSecretHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listSecrets = server.registerTool(
  'listSecrets',
  {
    title: 'List secrets',
    description: 'List the organization\'s secrets with pagination and sorting. Values are never included. Requires the `secrets:read` permission.',
    inputSchema: {
      queryParams: ListSecretsQueryParams
    },
    outputSchema: ListSecretsResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listSecretsHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getSecret = server.registerTool(
  'getSecret',
  {
    title: 'Get secret',
    description: 'Get a secret\'s metadata. The value is never included. Requires the `secrets:read` permission.',
    inputSchema: {
      pathParams: GetSecretParams
    },
    outputSchema: GetSecretResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getSecretHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.updateSecret = server.registerTool(
  'updateSecret',
  {
    title: 'Update secret',
    description: 'Update a secret\'s display name or description, or rotate its live or test value. Rotation overwrites the stored value — previous values are not retrievable.\n\nThe `env_key` is immutable: consumers of the secret receive the value under that key, so changing it would silently break them. Create a new secret instead.\n\nRequires the `secrets:write` permission.',
    inputSchema: {
      pathParams: UpdateSecretParams,
      bodyParams: UpdateSecretBody.optional()
    },
    outputSchema: UpdateSecretResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => updateSecretHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.deleteSecret = server.registerTool(
  'deleteSecret',
  {
    title: 'Delete secret',
    description: 'Delete a secret and detach it from all entities. Requires the `secrets:write` permission.',
    inputSchema: {
      pathParams: DeleteSecretParams
    },
    outputSchema: DeleteSecretResponse,
    annotations: { destructiveHint: true, idempotentHint: true },
  },
  (args, ctx) => deleteSecretHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.createSchedule = server.registerTool(
  'createSchedule',
  {
    title: 'Create a schedule',
    description: 'Create a schedule that performs an action, either repeatedly or once.\n\n`action` describes \*\*what\*\* happens — today only `trigger_worker`, which starts a worker run with the given scope. `rule` describes \*\*when\*\*: `recurring` carries one or more `patterns`, and fires whenever any of them comes round. A pattern fires every hour at `minute`, narrowed by `hours` and `weekdays` — so `hours: [9]` is daily at 09:00, `hours: [12], weekdays: [1]` is Mondays at noon, and `hours: [9, 13, 17], weekdays: [1, 2, 3, 4, 5]` is three times a day on weekdays. Give a second pattern to mix cadences: hourly on weekdays plus 09:00, 11:00 and 18:00 at weekends is two patterns on one schedule. Patterns overlap harmlessly — two that land on the same minute fire once. Every set is read in the schedule\'s own time zone — an IANA identifier such as `America\/Chicago`, resolved across DST transitions. `once` fires a single time at a UTC instant.\n\n`environments` says \*\*which worker version\*\* each occurrence runs: `live` resolves the worker at its live version, `test` at its test version. Give both to soak a candidate version on the same cadence and scope as production — every occurrence then fires twice, producing one run per environment. Omit it to fire in `live` only.\n\nThe response\'s `next_run_at` is the first occurrence strictly after the moment of creation; a rule that resolves to no such occurrence is rejected. Create with `enabled: false` to stage a recurring schedule without letting it fire. A one-off is always enabled: delete it to cancel it, and its `next_run_at` becomes null once it has fired.\n\nRequires the `schedules:write` permission.',
    inputSchema: {
      bodyParams: CreateScheduleBody.optional()
    },
    outputSchema: CreateScheduleResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => createScheduleHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listSchedules = server.registerTool(
  'listSchedules',
  {
    title: 'List schedules',
    description: 'List the organization\'s schedules. Requires the `schedules:read` permission.',
    inputSchema: {
      queryParams: ListSchedulesQueryParams
    },
    outputSchema: ListSchedulesResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listSchedulesHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getSchedule = server.registerTool(
  'getSchedule',
  {
    title: 'Get a schedule',
    description: 'Retrieve a single schedule. Requires the `schedules:read` permission.',
    inputSchema: {
      pathParams: GetScheduleParams
    },
    outputSchema: GetScheduleResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getScheduleHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.updateSchedule = server.registerTool(
  'updateSchedule',
  {
    title: 'Update a schedule',
    description: 'Update a schedule\'s rule, environments, name, or enabled state.\n\nChanging the rule moves `next_run_at` to the first occurrence after the update; a rule that resolves to no such occurrence is rejected. One-off schedules are always enabled — delete one to cancel it before it fires.\n\n`environments` replaces the whole list rather than adding to it. It takes effect from the next occurrence: one already due keeps the environments it was created with.',
    inputSchema: {
      pathParams: UpdateScheduleParams,
      bodyParams: UpdateScheduleBody.optional()
    },
    outputSchema: UpdateScheduleResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => updateScheduleHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.deleteSchedule = server.registerTool(
  'deleteSchedule',
  {
    title: 'Delete a schedule',
    description: 'Delete a schedule so it stops firing.',
    inputSchema: {
      pathParams: DeleteScheduleParams
    },
    outputSchema: DeleteScheduleResponse,
    annotations: { destructiveHint: true, idempotentHint: true },
  },
  (args, ctx) => deleteScheduleHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listDispatches = server.registerTool(
  'listDispatches',
  {
    title: 'List dispatches',
    description: 'List the organization\'s dispatches, newest occurrence first.\n\nA dispatch is one occurrence of a trigger in one environment, carried out on its own: a schedule produces one per environment it runs in every time it fires, an inbound email produces one for the environment its inbox received it in, and a resolved information request produces one that restarts the worker that asked. Listing them shows what a trigger has actually done, including occurrences that never produced anything.\n\n- `pending` — not carried out yet: waiting to be picked up, in flight, or waiting on a retry after an earlier pickup did not complete.\n- `dispatched` — carried out.\n- `abandoned` — gave up, because the occurrence passed its `expires_at` deadline before it could be carried out.\n\n`attempts` counts how many times the occurrence has been picked up, not how many times it failed: a dispatch carried out on the first pickup ends at `attempts: 1`, and a higher count means earlier pickups did not complete.\n\n`target` is what the occurrence produced — a worker run, or an extractor job for an email whose inbox extracts. It is null until the dispatch is carried out, and stays null on one that was abandoned.\n\nNarrow to one trigger with `trigger_type` and `trigger_id` — the schedule\'s ID for a schedule, the email\'s ID for an email, the request\'s ID for an information request. `trigger_id` requires `trigger_type`.',
    inputSchema: {
      queryParams: ListDispatchesQueryParams
    },
    outputSchema: ListDispatchesResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listDispatchesHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listNotifications = server.registerTool(
  'listNotifications',
  {
    title: 'List notifications',
    description: 'List the organization\'s notifications, newest first.\n\nA notification is a durable record that something happened and that somebody should know about it. Notifications are not yet addressed to individual people, so everyone in the organization sees the same feed.\n\n`title` and `body` are the display text — render them as-is rather than deriving your own wording from `type`, so every surface says the same thing. `data` carries the identifiers the notification points at, so a client can link to the thing it is about; which keys are present depends on `type`.\n\n`worker_issue_reported` means a worker hit a problem during a run and reported it; its `body` is the worker\'s own message and its `data` is the reporting `worker_id` and `run_id`. `information_request_created` means a worker paused to ask a person a question; its `data` is the `request_id` to answer through `POST \/v1\/information-requests\/{informationRequestId}\/resolve`.',
    inputSchema: {
      queryParams: ListNotificationsQueryParams
    },
    outputSchema: ListNotificationsResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listNotificationsHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.createInformationRequest = server.registerTool(
  'createInformationRequest',
  {
    title: 'Ask for information',
    description: 'Ask a person for a specific fact you cannot establish yourself.\n\nUse this when one missing piece of information is blocking you and only a human can supply it — which claim a document belongs to, which of two policies applies, what an ambiguous reference means. Ask one answerable question per request, and write it so it stands on its own: whoever resolves it sees your title and your question and nothing else.\n\nImmediately link the request to its case with `addCaseLinks` and `entity_type: \"information_request\"`. That is how it reaches the person working that case; unlinked, it sits in a queue nobody is looking at. Leave it unlinked only when you genuinely cannot tell which case it belongs to.\n\n\*\*This does not block or suspend you.\*\* Nobody resolves it while this run is happening. Carry on with what you can still do, or stop, and say in your final report that you asked.\n\nDo not use it for progress updates, or for anything you can work out yourself.',
    inputSchema: {
      bodyParams: CreateInformationRequestBody.optional()
    },
    outputSchema: CreateInformationRequestResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => createInformationRequestHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listInformationRequests = server.registerTool(
  'listInformationRequests',
  {
    title: 'List information requests',
    description: 'List the organization\'s information requests, newest first.\n\nAn information request is a specific question a worker could not settle on its own and needs a person to resolve. It stays open until somebody resolves it; there is no separate status field.',
    inputSchema: {
      queryParams: ListInformationRequestsQueryParams
    },
    outputSchema: ListInformationRequestsResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listInformationRequestsHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getInformationRequest = server.registerTool(
  'getInformationRequest',
  {
    title: 'Get information request',
    description: 'Retrieve a single information request by its ID.',
    inputSchema: {
      pathParams: GetInformationRequestParams
    },
    outputSchema: GetInformationRequestResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getInformationRequestHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.resolveInformationRequest = server.registerTool(
  'resolveInformationRequest',
  {
    title: 'Resolve information request',
    description: 'Resolve an open information request by providing an answer\/resolution.',
    inputSchema: {
      pathParams: ResolveInformationRequestParams,
      bodyParams: ResolveInformationRequestBody.optional()
    },
    outputSchema: ResolveInformationRequestResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => resolveInformationRequestHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.createTool = server.registerTool(
  'createTool',
  {
    title: 'Create tool',
    description: 'Create a new code tool that can be attached to agents. Provide the tool\'s name, code, and description.',
    inputSchema: {
      bodyParams: CreateToolBody.optional()
    },
    outputSchema: CreateToolResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => createToolHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listTools = server.registerTool(
  'listTools',
  {
    title: 'List tools',
    description: 'List all code tools with sorting.\n\nFor compatibility this endpoint is also available using the following (deprecated) paths:\n`GET \/worker\/v1\/tools`',
    inputSchema: {
      queryParams: ListToolsQueryParams
    },
    outputSchema: ListToolsResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listToolsHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.deleteTool = server.registerTool(
  'deleteTool',
  {
    title: 'Delete tool',
    description: 'Delete a tool. Fails with a conflict when the tool is still attached to a voice agent, worker, or chat agent; detach it first.',
    inputSchema: {
      pathParams: DeleteToolParams
    },
    outputSchema: DeleteToolResponse,
    annotations: { destructiveHint: true, idempotentHint: true },
  },
  (args, ctx) => deleteToolHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getTool = server.registerTool(
  'getTool',
  {
    title: 'Get tool',
    description: 'Retrieve a single tool by ID at its newest config version, including its code, schema, description and attached secrets, plus the versions each environment runs.\n\nFor compatibility this endpoint is also available using the following (deprecated) paths:\n`GET \/worker\/v1\/tools\/{id}`',
    inputSchema: {
      pathParams: GetToolParams
    },
    outputSchema: GetToolResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getToolHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.updateTool = server.registerTool(
  'updateTool',
  {
    title: 'Update tool',
    description: 'Update a code tool\'s name, description, code, or attached secrets. All fields are optional — only provided fields are updated.\n\nChanging the code, description or attached secrets creates a new config version; runs keep executing the versions promoted to live and test until that version is promoted. Renaming does not create a version.',
    inputSchema: {
      pathParams: UpdateToolParams,
      bodyParams: UpdateToolBody.optional()
    },
    outputSchema: UpdateToolResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => updateToolHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.executeCode = server.registerTool(
  'executeCode',
  {
    title: 'Execute tool',
    description: 'Execute a code tool with the given parameters. Returns the result, any errors, and execution traces.\n\nFor compatibility this endpoint is also available using the following (deprecated) paths:\n`POST \/worker\/v1\/tools\/{id}\/execute`',
    inputSchema: {
      pathParams: ExecuteCodeParams,
      bodyParams: ExecuteCodeBody.optional()
    },
    outputSchema: ExecuteCodeResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => executeCodeHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listToolVersions = server.registerTool(
  'listToolVersions',
  {
    title: 'List tool versions',
    description: 'List all config versions for a tool, ordered by version (newest first by default).',
    inputSchema: {
      pathParams: ListToolVersionsParams,
      queryParams: ListToolVersionsQueryParams
    },
    outputSchema: ListToolVersionsResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listToolVersionsHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getToolVersion = server.registerTool(
  'getToolVersion',
  {
    title: 'Get tool version',
    description: 'Retrieve a single tool config version: the tool\'s identity, the code, schema, description and attached secrets at that version, and version metadata.',
    inputSchema: {
      pathParams: GetToolVersionParams
    },
    outputSchema: GetToolVersionResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getToolVersionHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.promoteToolVersion = server.registerTool(
  'promoteToolVersion',
  {
    title: 'Promote tool version',
    description: 'Select a tool config version for the live or test environment. Runs in that environment execute this version\'s code with this version\'s schema and attached secrets from then on.',
    inputSchema: {
      pathParams: PromoteToolVersionParams,
      bodyParams: PromoteToolVersionBody.optional()
    },
    outputSchema: PromoteToolVersionResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => promoteToolVersionHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getToolVersionChangeSummary = server.registerTool(
  'getToolVersionChangeSummary',
  {
    title: 'Get tool version change summary',
    description: 'Returns an AI-generated summary of what changed between this version and the previous one. Initial version returns an empty string since there is no predecessor.',
    inputSchema: {
      pathParams: GetToolVersionChangeSummaryParams
    },
    outputSchema: GetToolVersionChangeSummaryResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getToolVersionChangeSummaryHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.workerListTools = server.registerTool(
  'workerListTools',
  {
    title: 'List tools',
    description: 'List all code tools with sorting.',
    inputSchema: {
      queryParams: WorkerListToolsQueryParams
    },
    outputSchema: WorkerListToolsResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => workerListToolsHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.workerGetTool = server.registerTool(
  'workerGetTool',
  {
    title: 'Get tool',
    description: 'Retrieve a single tool by ID at its newest config version, including its code, schema, description and attached secrets, plus the versions each environment runs.',
    inputSchema: {
      pathParams: WorkerGetToolParams
    },
    outputSchema: WorkerGetToolResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => workerGetToolHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.workerExecuteTool = server.registerTool(
  'workerExecuteTool',
  {
    title: 'Execute tool',
    description: 'Execute a code tool with the given parameters. Returns the result, any errors, and execution traces.',
    inputSchema: {
      pathParams: WorkerExecuteToolParams,
      bodyParams: WorkerExecuteToolBody.optional()
    },
    outputSchema: WorkerExecuteToolResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => workerExecuteToolHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.notifyAdmin = server.registerTool(
  'notifyAdmin',
  {
    title: 'Notify an admin',
    description: 'Report a problem to the people who run this organization.\n\nUse this for something a human has to resolve — a login that no longer works, a document you cannot read, a system that will not let you in, instructions that contradict what you found. The report goes to the organization\'s notifications; nobody sees it while the run is happening, so it does not unblock you now. Carry on with what you can still do, or stop, and say in your final report that you raised it.\n\nDo not use it for progress updates or for anything you can work around yourself.',
    inputSchema: {
      bodyParams: NotifyAdminBody.optional()
    },
    outputSchema: NotifyAdminResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => notifyAdminHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.uploadFile = server.registerTool(
  'uploadFile',
  {
    title: 'Upload a file for processing',
    description: 'Upload a file for processing by passing a URL to a file. Use this for uploading larger files.\n\nThis endpoint returns an upload id that can be used to find the created artifacts using the list artifacts endpoint.',
    inputSchema: {
      bodyParams: UploadFileBody.optional()
    },
    outputSchema: UploadFileResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => uploadFileHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.createAgentWebhook = server.registerTool(
  'createAgentWebhook',
  {
    title: 'Create voice agent webhook',
    description: 'Create a webhook that fires when events occur for the specified voice agent.\n\nFor compatibility this endpoint is also available using the following (deprecated) paths:\n`POST \/v1\/agents\/{id}\/webhooks`',
    inputSchema: {
      pathParams: CreateAgentWebhookParams,
      bodyParams: CreateAgentWebhookBody.optional()
    },
    outputSchema: CreateAgentWebhookResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => createAgentWebhookHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listAgentWebhooks = server.registerTool(
  'listAgentWebhooks',
  {
    title: 'List voice agent webhooks',
    description: 'List all webhooks configured for a specific voice agent.\n\nFor compatibility this endpoint is also available using the following (deprecated) paths:\n`GET \/v1\/agents\/{id}\/webhooks`',
    inputSchema: {
      pathParams: ListAgentWebhooksParams,
      queryParams: ListAgentWebhooksQueryParams
    },
    outputSchema: ListAgentWebhooksResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listAgentWebhooksHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.createInboxWebhook = server.registerTool(
  'createInboxWebhook',
  {
    title: 'Create inbox webhook',
    description: 'Create a webhook that fires when events occur for the specified inbox.\n\nFor compatibility this endpoint is also available using the following (deprecated) paths:\n`POST \/v1\/email-agents\/{id}\/webhooks`',
    inputSchema: {
      pathParams: CreateInboxWebhookParams,
      bodyParams: CreateInboxWebhookBody.optional()
    },
    outputSchema: CreateInboxWebhookResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => createInboxWebhookHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listInboxWebhooks = server.registerTool(
  'listInboxWebhooks',
  {
    title: 'List inbox webhooks',
    description: 'List all webhooks configured for a specific inbox.\n\nFor compatibility this endpoint is also available using the following (deprecated) paths:\n`GET \/v1\/email-agents\/{id}\/webhooks`',
    inputSchema: {
      pathParams: ListInboxWebhooksParams,
      queryParams: ListInboxWebhooksQueryParams
    },
    outputSchema: ListInboxWebhooksResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listInboxWebhooksHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.createExtractorWebhook = server.registerTool(
  'createExtractorWebhook',
  {
    title: 'Create extractor webhook',
    description: 'Create a webhook that fires when extraction events occur for the specified extractor.',
    inputSchema: {
      pathParams: CreateExtractorWebhookParams,
      bodyParams: CreateExtractorWebhookBody.optional()
    },
    outputSchema: CreateExtractorWebhookResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => createExtractorWebhookHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listWebhooks = server.registerTool(
  'listWebhooks',
  {
    title: 'List extractor webhooks',
    description: 'List all webhooks configured for a specific extractor.',
    inputSchema: {
      pathParams: ListWebhooksParams,
      queryParams: ListWebhooksQueryParams
    },
    outputSchema: ListWebhooksResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listWebhooksHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.createNotificationWebhook = server.registerTool(
  'createNotificationWebhook',
  {
    title: 'Create notification webhook',
    description: 'Create a webhook that fires whenever a notification is raised for the organization.\n\nNotifications belong to the organization rather than to a resource, so this webhook is not attached to anything: its `scope` is `{ \"notifications\": true }` and it receives every notification the organization raises. Each delivery carries the notification\'s `title` and `body` — the same display text `GET \/v1\/notifications` returns — alongside the structured `data` it points at.\n\nNotifications are not environment-specific, so every delivery is `live`. A webhook that names only `test` receives nothing.',
    inputSchema: {
      bodyParams: CreateNotificationWebhookBody.optional()
    },
    outputSchema: CreateNotificationWebhookResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => createNotificationWebhookHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listNotificationWebhooks = server.registerTool(
  'listNotificationWebhooks',
  {
    title: 'List notification webhooks',
    description: 'List the webhooks that receive the organization\'s notifications.',
    inputSchema: {
      queryParams: ListNotificationWebhooksQueryParams
    },
    outputSchema: ListNotificationWebhooksResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listNotificationWebhooksHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.deleteWebhook = server.registerTool(
  'deleteWebhook',
  {
    title: 'Delete webhook',
    description: 'Permanently delete a webhook. This action is irreversible.',
    inputSchema: {
      pathParams: DeleteWebhookParams
    },
    outputSchema: DeleteWebhookResponse,
    annotations: { destructiveHint: true, idempotentHint: true },
  },
  (args, ctx) => deleteWebhookHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.getWebhook = server.registerTool(
  'getWebhook',
  {
    title: 'Get webhook',
    description: 'Retrieve a single webhook by ID. The authentication header value is never exposed — only `has_auth` indicates whether authentication is configured.',
    inputSchema: {
      pathParams: GetWebhookParams
    },
    outputSchema: GetWebhookResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => getWebhookHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.updateWebhook = server.registerTool(
  'updateWebhook',
  {
    title: 'Update webhook',
    description: 'Update a webhook\'s name, destination, environments, enabled state, or authentication. Omitted fields are left unchanged, and at least one must be provided.',
    inputSchema: {
      pathParams: UpdateWebhookParams,
      bodyParams: UpdateWebhookBody.optional()
    },
    outputSchema: UpdateWebhookResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => updateWebhookHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.listWebhookDeliveries = server.registerTool(
  'listWebhookDeliveries',
  {
    title: 'List webhook deliveries',
    description: 'List delivery attempts for a specific webhook, with pagination and sorting. Useful for debugging webhook issues.',
    inputSchema: {
      pathParams: ListWebhookDeliveriesParams,
      queryParams: ListWebhookDeliveriesQueryParams
    },
    outputSchema: ListWebhookDeliveriesResponse,
    annotations: { readOnlyHint: true },
  },
  (args, ctx) => listWebhookDeliveriesHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

tools.testWebhook = server.registerTool(
  'testWebhook',
  {
    title: 'Test webhook',
    description: 'Send a test event to a webhook endpoint. Returns the HTTP status code, response time, and any errors. The request is rejected with a 400 if the webhook does not target the given environment, since a successful ping would say nothing about events it will never receive.',
    inputSchema: {
      pathParams: TestWebhookParams,
      bodyParams: TestWebhookBody.optional()
    },
    outputSchema: TestWebhookResponse,
    annotations: { destructiveHint: true },
  },
  (args, ctx) => testWebhookHandler(args, {
    ...options,
    signal: options?.signal ? AbortSignal.any([options.signal, ctx.signal]) : ctx.signal,
  })
);

  return { server, tools };
};


const { server } = createMcpServer();
const transport = new StdioServerTransport();

server.connect(transport).then(() => {
  console.error('MCP server running on stdio');
}).catch(console.error);
